import React, { useState, useEffect } from 'react';
import { usePushNotifications } from './usePushNotifications';
import { useTheme } from './useTheme';

const font = "'DM Sans', sans-serif";
const C = { turquesa: '#5dc1b9', mango: '#FDBE02' };
const LS_KEY = 'td_push_prompt_dismissed';

export default function PushPrompt() {
  const { subscribe, isSubscribed, supported } = usePushNotifications();
  const t = useTheme();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!supported) return;
    if (isSubscribed) return;
    if (localStorage.getItem(LS_KEY)) return;
    const timer = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(timer);
  }, [supported, isSubscribed]);

  const handleYes = async () => {
    setLoading(true);
    await subscribe();
    setLoading(false);
    setVisible(false);
    localStorage.setItem(LS_KEY, '1');
  };

  const handleNo = () => {
    setVisible(false);
    localStorage.setItem(LS_KEY, '1');
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 90,
      right: 20,
      zIndex: 9999,
      background: t.card || '#fff',
      border: `1px solid ${t.border || '#eee'}`,
      borderRadius: 16,
      padding: '16px 20px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
      maxWidth: 300,
      fontFamily: font,
      color: t.text || '#222',
      animation: 'slideUpFade 0.4s ease',
    }}>
      <style>{`@keyframes slideUpFade{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}`}</style>
      <p style={{ fontSize: 14, fontWeight: 600, margin: '0 0 6px' }}>
        Quieres recibir notificaciones?
      </p>
      <p style={{ fontSize: 12, color: t.textSecondary || '#888', margin: '0 0 12px', lineHeight: 1.5 }}>
        Te avisamos de eventos, nuevos recursos y novedades de la comunidad.
      </p>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          onClick={handleYes}
          disabled={loading}
          style={{
            flex: 1,
            padding: '8px 0',
            borderRadius: 10,
            border: 'none',
            background: C.turquesa,
            color: '#fff',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: font,
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? '...' : 'Si'}
        </button>
        <button
          onClick={handleNo}
          style={{
            flex: 1,
            padding: '8px 0',
            borderRadius: 10,
            border: `1px solid ${t.border || '#ddd'}`,
            background: 'transparent',
            color: t.textSecondary || '#888',
            fontSize: 13,
            fontWeight: 500,
            cursor: 'pointer',
            fontFamily: font,
          }}
        >
          No, gracias
        </button>
      </div>
    </div>
  );
}
